import React, { useState } from "react";
import Button from "components/BaseWidgets/button";
import Avatar from "components/BaseWidgets/Avatar";
import "./style.scss";
import {
  LikePost,
  LikesIcon,
  DislikesIcon,
  DislikePost,
  Comments,
  PostComments,
  SavePost,
  ShareIcon,
} from "assets/icons";
import Divider from "components/BaseWidgets/divider";
import ShareModal from "components/CustomWidgets/shareModal";
import { useBlogDisLike, useBlogLike, useBlogSave } from "hooks/api/useBlogs";
import { useQueryClient } from "@tanstack/react-query";
import { displayTextOrDash } from "utils/formatHelper";
import defaultImage from 'assets/images/png/default-user.png'

function BlogDetailHead({
  blogId,
  blogTitle,
  bannerImage,
  userImage,
  buttonText,
  quotedName,
  quotedTime,
  blogLikes,
  blogDislikes,
  blogComments,
  isDislike,
  isLike,
  isSaved,
  onCommentClick,
  shareurl,
  isSuccess = false,
}) {
  const [openModal, setOpenModal] = useState(false);
  const queryClient = useQueryClient();

  //blog like
  const { mutate: likeBlog, isLoading: liking } = useBlogLike({
    onSuccess: () => {
      queryClient.invalidateQueries(["blogDetails", blogId]);
    },
  });

  //blog dislike
  const { mutate: dislikeBlog, isLoading: disliking } = useBlogDisLike({
    onSuccess: () => {
      queryClient.invalidateQueries(["blogDetails", blogId]);
    },
  });

  //blog save
  const { mutate: saveBlog, isLoading: SaveblogLoading } = useBlogSave({
    onSuccess: () => {
      queryClient.invalidateQueries(["blogDetails", blogId]);
    },
  });

  const handleLike = () => {
    if (!liking) {
      likeBlog(blogId);
    }
  };

  const handledisLike = () => {
    if (!disliking) {
      dislikeBlog(blogId);
    }
  };

  const handleblogsave = () => {
    if (!SaveblogLoading) {
      saveBlog(blogId);
    }
  };
  const handleCancel = () => {
    setOpenModal(false);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  return (
    <div className={`blog-head-section ${isSuccess ? "success-layout" : ""}`}>
      <h1 className="font-title-xxxxl blogtitle">{blogTitle}</h1>
      <div className="blog-author-info flex justify-between">
        <div className="author">
          {!isSuccess && <Avatar url={userImage} />}
          <div className="quoted-by">
            <p className="user-name font-title-xs leading-1">
              {displayTextOrDash(quotedName)}
            </p>
            <span className="user-time font-body-normal fw-400 grey-shade">
              {displayTextOrDash(quotedTime)}
            </span>
          </div>
          {!isSuccess && (
            <>
              <Divider type="vertical" className="custom-divider" />
              <div className="blog-review flex items-center">
                <span className="review-box flex items-center">
                  <span className="icon-wrapper">
                    <LikesIcon width="20" height="20" />
                  </span>
                  <span className="font-body-lg fw-500">{blogLikes}</span>
                </span>
                <span className="review-box flex items-center">
                  <span className="icon-wrapper">
                    <DislikesIcon width="20" height="20" />
                  </span>
                  <span className="font-body-lg fw-500">{blogDislikes}</span>
                </span>
                <div className="review-box flex items-center">
                  <span className="icon-wrapper">
                    <Comments width="20" height="20" />
                  </span>
                  <span className="font-body-lg fw-500">{blogComments}</span>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="action-box flex gap-3">
          {isSuccess ? (
            <Button variant="round" onClick={handleOpenModal}>
              <span className="icon-wrapper">
                <ShareIcon width="20" height="20" />
              </span>
            </Button>
          ) : (
            <>
              <Button variant="round" onClick={handleLike} disabled={liking}>
                <span className="icon-wrapper">
                  <LikePost
                    width="20"
                    height="20"
                    stroke={isLike ? "#1E5611" : "#0A0A0A"}
                    fill={isLike ? "#C2E0B4" : "none"}
                  />
                </span>
              </Button>
              <Button
                variant="round"
                onClick={handledisLike}
                disabled={disliking}
              >
                <span className="icon-wrapper">
                  <DislikePost
                    width="20"
                    height="20"
                    stroke={isDislike ? "#561112" : "#0A0A0A"}
                    fill={isDislike ? "#E0B4B4" : "none"}
                  />
                </span>
              </Button>
              <Button variant="round" onClick={onCommentClick}>
                <span className="icon-wrapper">
                  <PostComments width="20" height="20" />
                </span>
              </Button>
              <Button
                variant="round"
                onClick={handleblogsave}
                disabled={SaveblogLoading}
              >
                <span className="icon-wrapper">
                  <SavePost
                    width="20"
                    height="20"
                    stroke="#0A0A0A"
                    fill={isSaved ? "#0A0A0A" : "none"}
                  />
                </span>
              </Button>
            </>
          )}
        </div>
      </div>
      <div className="blog-banner-section">
        <img
          className="blog-banner-pic"
          src={bannerImage ? bannerImage : defaultImage}
          alt={`${quotedName}-img`}
        />
      </div>
      <ShareModal
        open={openModal}
        onCancel={handleCancel}
        defaultLink={shareurl || "https://www./profile/3SFYVmsYTIDUfnIs"}
      />
    </div>
  );
}

export default BlogDetailHead;
